import React from 'react';
import {withTranslation} from "react-i18next";

const CheckBookForm = ({ t }) => (
    <div className="payment-type-bloc">
        <p className="payment-text">
            <span className="cards-title">{t('followup.check_order')} :</span><br />
            La Malle Postale<br /><br />
            <span className="cards-title">{t('followup.check_address')} :</span><br />
            La Malle Postale<br />
            11, av Charles Dupuy<br />
            43000 Le Puy-en-Velay
        </p>
    </div>
);

export default withTranslation()(CheckBookForm);
